/**
 * poll_adaptive_v1: poll ถี่เท่าที่จำเป็น
 *
 * ตอน SSE ต่ออยู่ ข้อมูลมาเองแบบ realtime อยู่แล้ว — poll เป็นแค่ตาข่ายกันเคส
 * "SSE เงียบไปเฉยๆ โดยไม่ error" (เช่นโดน proxy กั๊ก stream) จึงใช้จังหวะห่างได้
 * พอ SSE หลุดเมื่อไหร่ ค่อยกลับไปถี่เท่าเดิมทันที
 *
 * ใช้ setTimeout ต่อกันเป็นทอดๆ แทน setInterval เพราะต้องเปลี่ยนจังหวะกลางคันได้
 */
import { useEffect, useRef } from 'react';
import { isSSEConnected, onSSEStatus } from './sse';

export function useAdaptivePoll(fn, options) {
  const { fastMs, slowMs, enabled = true } = options;
  const fnRef = useRef(fn);
  fnRef.current = fn; // อ่านฟังก์ชันล่าสุดเสมอ — จะได้ไม่ต้อง restart timer ตอน re-render

  useEffect(() => {
    if (!enabled) return undefined;

    let timer = null;
    let stopped = false;

    const schedule = () => {
      if (stopped) return;
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        try { fnRef.current(); } catch (e) { console.error('[poll] error:', e); }
        schedule();
      }, isSSEConnected() ? slowMs : fastMs);
    };

    schedule();
    // SSE ต่อได้/หลุด -> คำนวณจังหวะถัดไปใหม่ทันที ไม่ต้องรอรอบปัจจุบันหมด
    const off = onSSEStatus(() => schedule());

    return () => {
      stopped = true;
      if (timer) clearTimeout(timer);
      off();
    };
  }, [fastMs, slowMs, enabled]);
}
